module.exports = __webpack_public_path__ + "img/202304.b16da848.png";